'use client';

import { ReactNode, useCallback, useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import clsx from 'clsx';
import { GlowButton, Icons } from '@headless-workspace/glow-ds';
import { useIsMounted } from 'usehooks-ts';
import { ShopTheFuture } from './ShopTheFuture';
import { useSitePreviewStorage } from './useSitePreviewStorage';

type SitePreviewProps = {
    customerGroups: string[];
};

export const SitePreview = ({ customerGroups }: SitePreviewProps): ReactNode => {
    const t = useTranslations('Preview.shopInTheFuture');
    const [showControls, setShowControls] = useState(false);
    const { isSitePreviewClosed, closeSitePreview } = useSitePreviewStorage();
    const isMounted = useIsMounted();
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    const onClick = () => {
        setShowControls(!showControls);
    };

    const onClose = () => {
        setShowControls(false);
    };
    const onPreviewHide = useCallback(() => {
        closeSitePreview();
    }, [closeSitePreview]);

    useEffect(() => {
        setIsPreviewOpen(!isMounted() || isSitePreviewClosed);
    }, [isMounted, isSitePreviewClosed]);

    if (isPreviewOpen) {
        return null;
    }

    return (
        <div className={'flex flex-col absolute z-sitePreview max-w-eighty overflow-hidden'}>
            <GlowButton
                Icon={Icons.Setting}
                label={t('label.title')}
                onClick={onClick}
                variant={'tertiary'}
                width={'full'}
                className={'!whitespace-normal'}
            />
            <ShopTheFuture
                customerGroups={customerGroups}
                className={clsx(showControls ? 'mt-0.5' : 'hidden')}
                onPreviewClose={onClose}
                onPreviewHide={onPreviewHide}
            />
        </div>
    );
};
